import React, { useEffect, useState } from 'react';
import { Checkbox, Radio, Icon, Bubble } from 'tea-component';

import * as styles from './item.module.less';
import { ItemProps } from '../type';
import { importImg } from '../../utils';
import { HALF, GLOBAL, GLOBAL_NO_CHINA } from '../../contants';
import { getLocaleText } from '@/pages/home/components/RegionSelect/locale';
import SvgIcon from '../../../SvgIcon';

const Item = (props: ItemProps) => {
  const {
    id,
    name,
    cnname,
    market,
    showChinese,
    radio = false,
    activeItem,
    selectStatus,
    disabled,
    globalMsg = getLocaleText('global_message'),
    children = [],
    childrenSelectList: childrenSelectListProps,
    globalMessageHidden,
    svgSrc,
    activeItemOnchange,
  } = props;
  const [isHover, setIsHover] = useState(false);
  const hasChildren = children?.length > 0;
  const isActive = activeItem?.id === id;
  const indeterminate = selectStatus === HALF;

  const handleClick = (checked?: boolean) => {
    setTimeout(() => {
      let childrenSelectList = childrenSelectListProps;
      if (checked !== undefined) {
        if (checked) {
          childrenSelectList = children?.map((market) => market?.id);
        } else {
          childrenSelectList = [];
        }
      }
      activeItemOnchange?.({
        id,
        name,
        cnname,
        children,
        childrenSelectList,
      });
    }, 100);
  };

  // 渲染 radio
  const renderRadioItem = (id: string, name: string, cnname: string) => {
    return (
      <Radio
        className={styles['global-ratio']}
        disabled={disabled}
        name={id}
        onChange={handleClick}
      >
        {id === GLOBAL ? (
          <span
            style={{ display: 'flex', alignItems: 'center' }}
            onMouseOver={() => {
              setIsHover(true);
            }}
            onMouseOut={() => {
              setIsHover(false);
            }}
          >
            {name}&nbsp;&nbsp;{showChinese ? <>{cnname}&nbsp;&nbsp;</> : ''}
            <>
              {!globalMessageHidden ? (
                <Bubble
                  style={{
                    // width: 350,
                    left: -18,
                  }}
                  placement="bottom-start"
                  content={globalMsg}
                  dark
                >
                  {/* 此处必须包一层，不然点击不生效 */}
                  <i>
                    <SvgIcon
                      className="select-header-ic"
                      type={isHover ? 'alert-circle-action' : 'alert-circle-m'}
                    />
                  </i>
                </Bubble>
              ) : null}
            </>
          </span>
        ) : (
          id === GLOBAL_NO_CHINA && (
            <Bubble content={showChinese ? cnname : name} dark>
              <span className={styles?.countryname}>
                {name}&nbsp;&nbsp;{showChinese ? cnname : ''}
              </span>
            </Bubble>
          )
        )}
      </Radio>
    );
  };

  return (
    <>
      {(hasChildren && (
        <div
          className={`
            ${styles['item-container']}
            ${isActive && styles.active}
          `}
          onClick={() => handleClick()}
        >
          <Checkbox
            disabled={disabled}
            name={id}
            indeterminate={indeterminate}
            onChange={handleClick}
          />
          <div className={styles.text}>
            <span>
              {name} {showChinese ? <>{cnname}&nbsp;&nbsp;</> : ''}(
              {children?.length})
            </span>
            <SvgIcon
              type="point-right"
              className={styles['item-container-icon']}
            />
          </div>
        </div>
      )) || (
        <div
          className={`
            ${styles['item-container']}
            ${isActive && styles.active}
            ${styles['no-children']}
            ${styles['item-container-all']}
          `}
        >
          {(radio && renderRadioItem(id, name, cnname)) || (
            <Checkbox
              disabled={disabled}
              onChange={handleClick}
              name={id}
              indeterminate={indeterminate}
            >
              {market && (
                <img
                  className={styles?.flag}
                  src={
                    id.toUpperCase() === '#N/A'
                      ? importImg(`global`)
                      : importImg(`${id.toLowerCase()}`)
                  }
                />
              )}
              <span
                ref={(e) => {
                  if (e?.clientHeight >= 32) {
                    e.className = styles?.countryname;
                    e.onmouseover = () => {
                      e.innerHTML += `<div style="display: block;
                        position: absolute;
                        background-color: #000;
                        left: 110px;
                        bottom: 20px;
                        color: #fff;
                        height: 30px;
                        line-height: 30px;
                        padding: 0 8px;">
                          <span>${showChinese ? cnname : ''}</span>
                          <i style="display: block;
                            width: 0;
                            height: 0;
                            border-left: 3px solid transparent;
                            border-right: 3px solid transparent;
                            border-top: 3px solid #000;
                            position: absolute;
                            left: 50%;
                            bottom: -3px;
                            transform: translateX(-50%);
                          "></i>
                        </div>`;
                    };
                    e.onmouseout = () => {
                      e.innerHTML = e.innerHTML.split('<')[0];
                    };
                  }
                }}
              >
                {name} {showChinese ? cnname : ''}
              </span>
            </Checkbox>
          )}
        </div>
      )}
    </>
  );
};

export default Item;
